import * as React from 'react';
import { useQuery } from "graphql-hooks";
import Helper from '../../../utilities/helper'
import { useLocation } from 'react-router-dom';
import { ACCESS_VALUES, PageNames } from '../../../utilities/constValues';
import { PermissionsGate } from '../../../utilities/PermissionsGate';
import { Hero } from "../../Shared/Hero";
import { Loading } from '../../Shared/Loading';
import { MetaTags } from "../../Shared/MetaTags";
import { ErrorPage } from '../../Shared/ErrorPage';
import { PermissionsRequired } from '../../Shared/PermissionsRequired';
import { NavigationCardSet } from '../../Shared/NavigationCards/NavigationCardSet';
import { Vehicles } from './Vehicles';
import { Chargers } from './Chargers';
import { AnchorLink, PageAnchors } from '../../Shared/PageAnchors';
import { useAPIErrorContext } from '../../../contexts/apiErrorContext';

const CMS_QUERY = `query datoQuery {
    pageData: pageElectrificationBasic {
        fieldHeroTitle
        fieldCardNavigationSectionTitle
        fieldNavigationCards {
            id
            fieldCardTitle
            fieldCardLink
            fieldCardContent
            fieldCardImage {
                alt
                url
                title
            }
        }
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
}`;

export const Basics = () => {
    const { loading, error, data } = useQuery(CMS_QUERY);
    const { trackError } = useAPIErrorContext();
    const location = useLocation();
    const pageAnchors: AnchorLink[] = [{ displayName: "Vehicles", hashLocation: "./#vehicles" },
        { displayName: "Chargers", hashLocation: "./#chargers" }];

    React.useEffect(() => {
        Helper.setPagePath(location.pathname);
    }, [location]);

    if (!error && !loading) {
        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.ElectrificationBasics}>
                <div className="electrificationBasics">
                    {/* Hero Section */}
                    <Hero pageTitle={data.pageData.fieldHeroTitle} />
                    <PageAnchors anchorLinks={pageAnchors} />
                    <Vehicles />
                    <Chargers />
                    <NavigationCardSet PageData={data.pageData} />
                    <MetaTags seoData={data.pageData.seo} />
                </div>
            </PermissionsGate>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
